import { LocalStorageService } from './../../../../core/services/local-storage.service';
import { environment } from './../../../../../environment/environment';
import { CompanyService } from './../../../../core/services/company/company.service';
import { EsnConsultantService } from './../../../../core/services/esn-consultant/esn-consultant.service';
import { DatePipe } from '@angular/common';
import { Component, ElementRef, TemplateRef } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastMessage } from './../../../../core/models/chapitreeval';
import { existedEvaluation, serverError, updatedEvaluation } from './../../../../core/models/messages';
import { EsnAppeloffreService } from './../../../../core/services/esn-appeloffre/esn-appeloffre.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import Swal from 'sweetalert2';
import { PrimeNGConfig } from 'primeng/api';
import { EvaluationService } from '@core/services/evaluation/evaluation.service';
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-template-evaluation',
  templateUrl: './template-evaluation.component.html',
  styleUrls: ['./template-evaluation.component.css'],
})
export class TemplateEvaluationComponent {
  parentItem = 'Template d\'évaluation vide';
  parentTextItem = 'merci de remplir la template d\'évaluation';
  // user_ids:any
  sendForm: FormGroup = this.createtemplateForm();
  templateSListESN: any;
  listIds: any = [];
  listEvaluation :any;
  totalItems!: number;
  currentSortDirection: number = 2;
  itemsPerPage: number = 5;
  /* formGroup */
  loadSpinnerTable: boolean = false;
  startIndex: number = 0;
  endIndex: number = 5;
  file: any;
  fileError: string = '';
  fileExtention: string = '';
  searchForm: FormGroup = this.createSearchForm();
  /* unsubscription */
  private unsubscribeAll: Subject<void> = new Subject();
  //@tofix: delete
  type = [
    { id: '1', name: 'Annuelle' },
    { id: '2', name: 'Suivi' },
  ];
  typesEvaluationTemplate = [
    { id: 'Annuelle', name: 'Annuelle' },
    { id: 'Suivi', name: 'Suivi' },
  ];
  private modalForm!: FormGroup;
  disabledenvoyer: boolean = false;
  checkedConsultantsIds: any = [];
  mode: string = 'create';
  modalRef?: BsModalRef;
  evaluation_id: any;
  //@tofix: Delete and replace with clone
  //evaluationForm: FormGroup = this.createevaluationForm();
  evaluationupdateForm: FormGroup = this.updateevaluationForm();
  formevaluationcloner: FormGroup = this.createevaluationclonerForm();
  formevaluationclonerAdmin : FormGroup = this.createevaluationclonerFormAdmin();
  listconsultant: any;
  sortAttr: string = '';
  user_ids: any[] = [];
  selectedUserIds: number[] = [];
  id!: number;
  company_id: any;
  idch!: string;
  searchValue: string = '';
  pagination : boolean =false;
  urlimage: string = environment.baseUrlGalery;
  url: string = environment.baseUrl + '/api';
  name: any;
  nameeval:any;
  searchFormTemplate: FormGroup = this.createSearchFormTemplate();
  startSearching:boolean = false;

  evaluationForm: FormGroup = this.createEvaluationForm();
  checkedBtnQuestions:boolean = false;

  pageSizeOptions = [5, 10, 20];
  pageSize = 5;
  currentPage = 0;
  totalElements = 0

  totalAdmin = 0;
  pageSizeAdmin = 5;
  currentPageAdmin = 0;
  idEval: any;
  constructor(
    private formBuilder: FormBuilder,
    private esnconsultantservice: EsnConsultantService,
    private modalService: BsModalService,
    private toastr: ToastrService,
    private ajouttemlateservice: EsnAppeloffreService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private templateservice: CompanyService,
    private datePipe: DatePipe,
    private localStorageService: LocalStorageService,
    private primengConfig: PrimeNGConfig,
    private elRef: ElementRef,
    private evaluationService : EvaluationService
  ) {}
  ngOnInit() {
    const scrollableTable = this.elRef.nativeElement.querySelector('#kt_customers_table');
    scrollableTable?.addEventListener('scroll', this.closeDropdownOnScroll.bind(this));
    this.getTemplateListEsn()
    this.getlistconsultant();
    this.getListEvaluation();
    this.modalForm = this.formBuilder.group({
      evaluation_id: [null],
      user_ids: [[]],
      evalname:[]
    });
    this.primengConfig.setTranslation({
      dayNames: ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
      dayNamesShort: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
      dayNamesMin: ["D", "L", "M", "M", "J", "V", "S"],
      monthNames: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
      monthNamesShort: ["Jan", "Fév", "Mar", "Avr", "Mai", "Juin", "Juil", "Aoû", "Sep", "Oct", "Nov", "Déc"],
      today: 'Aujourd\'hui',
      clear: 'Effacer'
    });
  }
  closeDropdownOnScroll(): void {
    // Find the open dropdown
    const dropdown = this.elRef.nativeElement.querySelector('.dropdown-menu.show');
    
    // If the dropdown is open, remove the 'show' class to close it without triggering a page scroll
    if (dropdown) {
      dropdown.classList.remove('show');
    }
  }

  formatDate(dateString: string | null): string {
    if (!dateString) {
      return '';
    }

    const date = new Date(dateString);
    return this.datePipe.transform(date, 'dd/mm/yyyy') || '';
  }
  //@tofix: to delete
  navigate(user : any,name : string) {
    this.router.navigate([
      '/evaluation/details-evaluation',
      { id: user,defaultReview_id:name},
    ]);
}

navigateToQuestions(idTemplate : number, typeTemplate: string) {
  this.router.navigate([
    '/evaluation/details-evaluation', { idTemplate,typeTemplate},
  ]);
}
  getlistconsultant() {
    this.esnconsultantservice.getlistconsultantbyoffre().subscribe({
      next: (res: any) => {
        this.listconsultant = res.data;
      },
      error: (error) => {
      },
    });
  }

  /********************** envoyer ******************************************* **/

  createtemplateForm(data?: any) {
    return this.formBuilder.group({
      user_ids: this.formBuilder.array(data?.user_ids || []),
    });
  }

  onSubmitonly() {
    if (
      this.evaluationForm.invalid ||
      !this.templateSListESN ||
      this.templateSListESN.length === 0
    ) {
      return;
    }
    let user_idsArray = [this.user_ids[0].id];

    let data = {
      user_ids: user_idsArray,
      evaluation_id: this.evaluation_id,
    };
    this.spinner.show();
    this.ajouttemlateservice
      .envoyerEvaluationSend(data)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.spinner.hide();
          this.toastr.success("L'évaluation a été envoyée avec succès.");
          this.closeModal();
        },
        error: (err) => {
          this.spinner.hide();
          if (err?.error?.message?.name) {
          
          } else {
            this.toastr.error(serverError);
          }
        },
      });
  }

  open(template: TemplateRef<any>, id?: any) {
    this.modalRef = this.modalService.show(template);
    this.evaluation_id = id;
    this.checkedConsultantsIds = []; 
  }

  getChapitreById() {
   
    if (!this.evaluation_id) {

      return;
    }

    this.spinner.show();
    this.ajouttemlateservice
      .detailchapitre(this.evaluation_id)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.spinner.hide();
     
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }

  get user_idsArray() {
    return this.modalForm.get('user_ids') as FormArray;
  }

  /* ************************* navigation company ********************* */
  profilCompanyNavigation(id: any) {
    this.router.navigate([
      '/evaluation/details-evaluation',
      { id: id },
    ]);
  }

  deleteTemplate(templateEsn:any) {
    Swal.fire({
      title: 'Êtes-vous sûr(e) ?',
      text: 'Vous ne pourrez pas revenir en arrière !',
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Annuler',
      confirmButtonColor: '#3085D6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui, supprimer !',
      reverseButtons: true

    }).then((result) => {
      if (result.isConfirmed) {
        this.templateservice
          .deleteEvaluationDefault(templateEsn.id)
          .subscribe((res: any) => {
            Swal.fire(
              'Supprimé !',
              'Chapitre évaluation  a été supprimé.',
              'success'
            );
            this.getTemplateListEsn();
          });
      }
    });
  }

  toastMessages: ToastMessage = {
    success: 'Modification de votre Template évaluation réussie ',
    error: 'template evaluation avec ce nom existe déjà',
  };

  openModal(template: TemplateRef<any>, data?: any, mode?: string) {
    this.modalRef = this.modalService.show(template, { backdrop: 'static' });
    this.formevaluationcloner.get('evaluation_id')?.setValue(data.id);
    if (data) {
      this.id = data.id;

      this.evaluationForm = this.createevaluationForm(data);
    }
  }
  
  openModalaAdminClone(template: TemplateRef<any>, data?: any, mode?: string) {
    this.modalRef = this.modalService.show(template, { backdrop: 'static' });
    this.formevaluationclonerAdmin.get('evaluation_id')?.setValue(data.id);
    if (data) {
      this.id = data.evaluation_id;
      this.evaluationForm = this.createevaluationForm(data);
    }
  }
  openModalenvoyer(template: TemplateRef<any>, data?: any, mode?: string) {
    this.modalRef = this.modalService.show(template, { backdrop: 'static' });
  }
  createevaluationForm(data?: any) {
    return this.formBuilder.group({
      name: [data && data.name],
      type: [data && data.type],
      company_id: [this.localStorageService.getData('clientConnected')],
      id: [''],
    });
  }
  updateevaluationForm(data?: any) {
    return this.formBuilder.group({
      name: [data && data.name,Validators.required],
      //exsistName: [data && data.exsistName],
      type: [data && data.type,Validators.required],
      company_id: [this.localStorageService.getData('clientConnected')],
      id: [''],
    });
  }
  openModalupdate(template: TemplateRef<any>, data?: any, mode?: string) {
    this.modalRef = this.modalService.show(template, { backdrop: 'static' });

    if (data) {
      console.log('data update ',data)
      this.id = data.id;

      this.evaluationupdateForm = this.updateevaluationForm(data);
      //this.evaluationupdateForm.get('exsistName')?.setValue(data.name);
    }
  }
  //@tofix: to delete
 

  closeModal() {
    this.modalRef?.hide();
    this.formevaluationcloner.reset();
    this.file = null;
    this.fileError = '';
    this.fileExtention = '';
    this.getlistconsultant()
  }

  onCheckboxChange(event: any, data: any) {
    if (event.target.checked) {
      this.checkedConsultantsIds.push(data.uuid);
    } else {
      this.checkedConsultantsIds = this.checkedConsultantsIds.filter((uuid: any) => uuid !== data.uuid);
    }
  }

  createSearchForm(data?: any) {
    return this.formBuilder.group({
      consultant_name: ['', data?.consultant_name],
    });
  }

  applyFilter(event?: Event) {
    let filterValue = (event?.target as HTMLInputElement)?.value;
    if (event) this.searchValue = filterValue;
    if (!event) filterValue = this.searchValue;
    let data = {
      consultant_name: filterValue,

      esn_name: this.localStorageService.getData('clientConnectedName'),
    };
    this.spinner.show();
    this.esnconsultantservice
      .searchconsultantenvoyer(data)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.listconsultant = res.data;
          this.spinner.hide();
        },
        error: () => {
          this.toastr.error(serverError);
          this.spinner.hide();
        },
      });
  }

  createevaluationclonerForm(data?: any) {
    return this.formBuilder.group({
      evaluation_name: [data && data.name, [Validators.required]],
      evaluation_id: [''],
    });
  }
  createevaluationclonerFormAdmin(data?:any) {
    return this.formBuilder.group({
      evaluation_name: [data && data.name, [Validators.required]],
      evaluation_id: [''],
    });
  }
  toastMessages1: ToastMessage = {
    success: 'Cloner votre évaluation avec succès',
    error: 'Ce cloner not  exist',
  };
  clonerEvaluationAdminCloner() {
    const entrepriseTab = document.querySelector('a[href="#eval_entreprise"]') as HTMLElement;
    //console.log('yybbf id',this.formevaluationclonerAdmin.value.evaluation_id)
    if (this.formevaluationclonerAdmin.invalid) return
    if (entrepriseTab) {
      
      // Simulate a click on the tab to activate it
      this.spinner.show();
      this.ajouttemlateservice
        .clonagetemplateAdmin(this.formevaluationclonerAdmin.value.evaluation_id,this.formevaluationclonerAdmin.value)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {
            this.getTemplateListEsn();
            entrepriseTab.click();
            this.spinner.hide();
            this.toastr.success(this.toastMessages1.success);
            this.formevaluationclonerAdmin.reset();
            this.closeModal();
          },
  
          error: (err) => {
            this.spinner.hide();
            if (err?.error) {
              if (err.error.message['name']) {
                this.toastr.error('le nom d\'évaluation existe déja, veillez choisir un nouveau nom d\'évaluation');
              } else {
                this.toastr.error('le nom d\'évaluation existe déja, veillez choisir un nouveau nom d\'évaluation');
              }
            }
          },
        });
    }
    
  }
  clonerEvaluationCloner() {
    this.spinner.show();
    this.ajouttemlateservice
      .createnouveauevaluation(this.formevaluationcloner.value)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.spinner.hide();
          this.toastr.success(this.toastMessages1.success);
          this.formevaluationcloner.reset();
          this.closeModal();
        },
        error: (err) => {
          this.spinner.hide();
          if (err?.error) {
            if (err.error.message['name']) {
         
              this.toastr.error(this.toastMessages.error);
            } else {
              this.toastr.error(serverError);
            }
          }
        },
      });
  }

  /*search template evaluation*/
  createSearchFormTemplate(data?: any) {
    return this.formBuilder.group({
      name: [data ? data.name : null],
      type: [data ? data.type : null],
      creation_date: [data ? data.creation_date : null],
    });
  }
  getListEvaluation(pageNumber : number = this.currentPageAdmin) {
    let creationDate = this.searchFormTemplate.get('creation_date')?.value
    let data = {
      date: creationDate,
      type: this.searchFormTemplate.get('type')?.value,
      name: this.searchFormTemplate.get('name')?.value,
      per_page: this.pageSizeAdmin,
      page: pageNumber + 1
    };
    this.ajouttemlateservice
      .getListEvaluationDefault(data)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({

        next: (res) => {
          if (res?.status === 200) {
            this.spinner.hide();
            this.listEvaluation = res.data?.data;
            this.totalAdmin = res.data.total;
          } else {
            this.spinner.hide();
            this.toastr.error("Unexpected API response.");
          }
        },

        error: (err) => {
          this.spinner.hide();
          this.toastr.error("Failed to load evaluations. Please try again.");
          console.error(err);
        },
      });
  }
  resetEsn() {
    this.searchFormTemplate.reset();
    this.currentPage = 0;
    this.currentPageAdmin = 0;
    this.getTemplateListEsn();
    this.getListEvaluation()
  }

  ngOnDestroy() {
    const scrollableTable = this.elRef.nativeElement.querySelector('#kt_customers_table');
    scrollableTable?.addEventListener('scroll', this.closeDropdownOnScroll.bind(this));

  }

  onCheckboxQuestions(event: Event): void {
    const isChecked = (event.target as HTMLInputElement).checked;

    if (isChecked) {
      this.checkedBtnQuestions = true
    }
  }
  submitData() {
    if (this.mode == 'create') {
      this.addTemplate();
    } else {
      this.updateTemplate();
    }
  }
  openModalEval(template: TemplateRef<any>, mode: string, data?: any) {
    this.mode = mode;
    if (mode == 'update') {
      this.evaluation_id = data?.id;
    //  data.type = parseInt(data?.type);
      this.evaluationForm = this.createEvaluationForm(data);  
    }
    if (mode == 'create') {
      this.evaluationForm = this.createEvaluationForm(data);
    }
    this.modalRef = this.modalService.show(template, { backdrop: 'static' });
  }

  createEvaluationForm(data?: any) {
    return this.formBuilder.group({
      name: [
        data ? data.name : '',
        [Validators.required, this.notOnlySpacesValidator()],
      ],
      type: [data ? data.type : null, [Validators.required]],
      checkboxGestion: [false]
    });
  }
  notOnlySpacesValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value: string = control.value as string;
      const isValid = value?.trim() !== '';
      return isValid ? null : { onlySpaces: true };
    };
  }

  addTemplate() {
    if (this.evaluationForm.invalid) return

      this.spinner.show();
      this.evaluationService
        .addTemplate(this.evaluationForm.value)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {
            if (res.status == 200) {
              if(this.checkedBtnQuestions) {
                this.navigateToQuestions(res.data.id, 'ESN')
              }else {
                this.getTemplateListEsn()
                this.evaluationForm.reset()
              }
              this.closeModal();
              this.spinner.hide();
              this.toastr.success('L\'évaluation a été ajoutée avec succès.');
            }
          },
          error: (err) => {
            this.spinner.hide();
            if (err?.error) {
              if (err.error?.message && err.error?.message['name'])
                this.toastr.error(existedEvaluation);
              else this.toastr.error(serverError);
            }
          },
        });
  }
  
  updateTemplate() {
    if (this.evaluationForm.invalid) return

      this.spinner.show();

      let updatePayload = {
        name: this.evaluationForm.get('name')?.value,
        type: this.evaluationForm.get('type')?.value
      }
      this.templateservice
        .updateEvaluationDefault(this.evaluation_id, updatePayload)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {
            if (res.status == 200) {
              if(this.checkedBtnQuestions) {
                this.navigateToQuestions(res.data.id,'ESN')
              }else {
                this.getTemplateListEsn();
                this.evaluationForm.reset()
              }
              this.closeModal();
              this.spinner.hide();
              this.toastr.success(updatedEvaluation);
            }
          },
          error: (err) => {
            this.spinner.hide();
            if (err?.error) {
              if ( err.error?.message ==='An evaluation with this name and type already exists.'){
                this.toastr.error("Une évaluation de ce nom et de ce type existe déjà.");
              } else {
                this.toastr.error(serverError);
              }
            }
          },
        });
  }

  getTemplateListEsn(){
    this.spinner.show();

    let creationDate = this.searchFormTemplate.get('creation_date')?.value
    if(creationDate){
      creationDate = this.datePipe.transform(creationDate, 'yyyy-MM-dd');
    }
    const params = {
      per_page: this.pageSize,
      page: this.currentPage,
      template_type: this.searchFormTemplate.get('type')?.value,
      template_name: this.searchFormTemplate.get('name')?.value,
      template_date: creationDate
    }
    this.evaluationService
        .fetchTemplates(params)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {
            if (res.status == 200) {
              this.templateSListESN = res.data?.data
              this.totalElements = res.data?.total
              this.spinner.hide();
            }
          },
          error: (err) => {
            this.spinner.hide();
            if (err?.error) {
              if (err.error?.message && err.error?.message['name'])
                this.toastr.error(existedEvaluation);
              else this.toastr.error(serverError);
            }
          },
        });
  }

  /**
     * Handle page change event from the paginator.
     * @param event The page event containing the new page index and page size.
     */
  onPageChange(e: PageEvent): void {
        this.pageSize = e.pageSize;
        this.currentPage = e.pageIndex;
        this.getTemplateListEsn()
  }
  
  onPageChangeAdmin(e: PageEvent): void {
      this.pageSizeAdmin = e.pageSize;
      this.currentPageAdmin = e.pageIndex;
      this.getListEvaluation()
  }
  
  sendTemplate() {
        const payload = {
        consultant_ids: this.checkedConsultantsIds
      }
        this.spinner.show();
        this.evaluationService
          .sendTemplate(this.evaluation_id, payload)
          .pipe(takeUntil(this.unsubscribeAll))
          .subscribe({
            next: (res) => {
              if (res.status == 200) {
                this.closeModal();
                this.spinner.hide();
                this.toastr.success("L'évaluation a été envoyé avec succès.");
              }
            },
            error: (err) => {
              this.spinner.hide();
              if (err?.error) {
                if(err?.error?.message === "This evaluation has already been cloned for this consultant with the same questions and families."){
                  this.toastr.error("Vosu avez déja envoyé cette évaluation à ce consultant.");
                } else if( err?.error?.message ==="Failed to send evaluation: No questions available in this evaluation."){
                  this.toastr.error("La template est vide , vous devez avoir au moins une question.");
                } else{
                  this.toastr.error(serverError)
                }
              }
            },
          });
  }    
}
